// config.js
export const API_URL = 'https://test-springo92.herokuapp.com/api';
//export const API_URL = 'http://localhost:4500/api';
